import "./styles.scss"
import { ContentSectionContainer, fetchRoute, SenderModel } from "@cakemail-org/ui-components-v2"
import { Route, Routes } from "react-router-dom"
import { ERoutes } from "../../utils/url"
import { SendersListingContext } from "./context"
import SendersListing from "./containers/listing"

type TSendersProps = {
    // Optional Redux action from parent app
    // If provided, will use parent app's Redux state management
    setSingleSender?: (sender: SenderModel | null) => void
}

export default function Senders({ setSingleSender }: TSendersProps) {
    return (
        <ContentSectionContainer className="suppressionListContainer">
            <SendersListingContext.Provider value={{
                setSingleSender
            }}>
                <Routes>
                    <Route index path={fetchRoute({ route: ERoutes.senders })} element={<SendersListing />} />
                    <Route index path={"/"} element={<SendersListing />} />
                </Routes>
            </SendersListingContext.Provider>
        </ContentSectionContainer>
    )
}